import React from 'react';
import './Symptoms.scss';
import IconList from '../../components/IconList/IconList';
import SectionTitle from '../../components/SectionTitle/SectionTitle';
import iconOne from '../../assets/symptoms/1.png';
import iconTwo from '../../assets/symptoms/2.png';
import iconThree from '../../assets/symptoms/3.png';
import iconFour from '../../assets/symptoms/4.png';
import iconFive from '../../assets/symptoms/5.png';

const Symptoms = () => {
    const symptomsData = [
        {
            'icon' : iconOne,
            'title' : 'Dor espontânea',
            'description':'Dor mesmo quando você não está comendo ou bebendo' 
        },
        {
            'icon' : iconTwo,
            'title' : 'Descoloração do dente',
            'description':'Escurecimento ou descoloração de um dente' 
        },
        {
            'icon' : iconThree,
            'title' : 'Dor no meio da noite',
            'description':'Dor que te acorda no meio da noite' 
        },
        {
            'icon' : iconFour,
            'title' : 'Sensibilidade nas gengivas',
            'description':'De problemas com fio dental a dentes sensíveis, toda boca é bem-vinda.' 
        },
        {
            'icon' : iconFive,
            'title' : 'Sensibilidade extrema',
            'description':'Sensibilidade extrema ao frio ou calor ao beber ou comer' 
        }
    ]

    return (
        <section className='symptoms-section section-common pt-100 pb-70' data-aos="fade-up" data-aos-duration="2000">
            <div className="container">
                <SectionTitle 
                    subTitle="Sintomas"
                    title="Sinais e sintomas que indicam tratamento de canal"
                    description="Lorem ipsum é um texto de espaço reservado comumente usado em design gráfico, impressão e publicação para pré-visualizar layouts e maquetes visuais."
                />

                <div className="row">
                    {
                        symptomsData.map(singleSymptoms => 
                            <IconList 
                                icon={singleSymptoms.icon}
                                title={singleSymptoms.title}
                                description={singleSymptoms.description}
                            />
                        )
                    }
                </div>
            </div>
        </section>
    );
};

export default Symptoms;
